<template>
    <div>
        <!-- HEADER-->
        <div v-if="onlyComponent === false" class="row sticky-top mb-1 priceandpromo"
             style="top:0px;background-color:#f9f9f9;z-index:2;">
            <div class="col-12 col-md-4 d-flex align-items-center mt-1 mb-1">
                <div class="d-flex flex-fill">

                    <input-search-text ref="searchTextInput" @search="productList()"></input-search-text>

                </div>
            </div>
            <div class="col-12 col-md-8 text-md-end mb-1">
                <div class="d-flex me-0 me-sm-3 gap-3 justify-content-end">
                    <div>
                        <div>
                            <div v-for="(flagUrl, id) in flags" :key="flagUrl.code"
                                 class="form-check form-check-inline">
                                <input v-model="selectedChannels" :value="flagUrl.code" class="form-check-input"
                                       type="checkbox" @change="productList()">
                                <label class="form-check-label">{{ getSaleChannelName(id) }}</label>
                            </div>
                            <!-- Gold checkbox -->
                            <div class="form-check form-check-inline">
                                <input v-model="showGold" class="form-check-input"
                                       type="checkbox" @change="productList(1, true)">
                                <label class="form-check-label">Gold</label>
                            </div>
                        </div>
                    </div>

                    <button class="btn btn-icon btn-icon-only btn-foreground-alternate shadow" data-bs-original-title="Filtri avanzati"
                            data-bs-target="#advancedFilters" data-bs-toggle="modal"
                            type="button">
                        <svg class="acorn-icons acorn-icons-filter mb-3 d-inline-block text-primary" fill="none" height="20" stroke="currentColor" stroke-linecap="round"
                             stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 20 20" width="20"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15 2H5C4.44772 2 4 2.44772 4 3V6.21639C4 6.44606 4.07906 6.66873 4.22389 6.84698L7.4904 10.8673C7.63523 11.0456 7.71429 11.2682 7.71429 11.4979V16.0963C7.71429 16.475 7.92829 16.8213 8.26707 16.9907L10.8385 18.2764C11.5034 18.6088 12.2857 18.1253 12.2857 17.382V11.4979C12.2857 11.2682 12.3648 11.0456 12.5096 10.8673L15.7761 6.84698C15.9209 6.66873 16 6.44606 16 6.21639V3C16 2.44772 15.5523 2 15 2Z">
                            </path>
                        </svg>
                    </button>


                    <a class="btn btn-icon btn-icon-only btn-foreground-alternate shadow add-datatable"
                       data-bs-delay="0"
                       data-bs-original-title="Nuovo ordine" data-bs-placement="top" data-bs-toggle="tooltip" href="https://backoffice-stage.callmewine.co.uk/manual-orders/order" title=""
                       type="button">
                        <svg class="acorn-icons acorn-icons-plus " fill="none" height="20" stroke="currentColor" stroke-linecap="round"
                             stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 20 20" width="20"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 17 10 3M3 10 17 10"></path>
                        </svg>
                    </a>

                    <div class="me-1 mb-1 mr-5">
                        <a class="btn btn-primary mb-3" data-bs-delay="0" data-bs-original-title="Import promo"
                           data-bs-placement="top" data-bs-toggle="tooltip" href="/import-promotions" title=""
                           type="button">
                            IMPORT PROMO
                        </a>
                    </div>

                </div>
            </div>
            <div class="col-12">
                <div class="d-flex">
                    <div class="w-100">
                    </div>
                </div>
            </div>
        </div>

        <!-- END HEADER-->
        <div v-if="onlyComponent === false" class="no-shadow d-none d-lg-block sticky-top"
             style="top:47px;background-color:#f9f9f9;z-index:2;">
            <div class="pt-0 h-100">
                <div class="row row g-0 mb-2">
                    <div class="col-12 d-flex me-0 me-sm-3 gap-3" wire:ignore="">

                    </div>
                    <div class="mt-2 d-flex align-items-center justify-content-between w-100" style="font-size: 1rem; color: #000000;">
                        <div class="d-flex align-items-center gap-1">
                            <span class="text-medium">Total Products:</span>
                            <span class="fw-bold text-medium">{{ pagination.totalElements }}</span>
                        </div>
                        <div class="d-flex align-items-center" style="border: 2px solid #dbdbdb; border-radius: 20px; padding: 4px 12px; font-size: 14px !important;">
                            <span style="color: #000000;">
                                If you want to avoid lateral scrolling, zoom out to 90% or collapse the menu
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- BODY PAGE -->
        <div v-for="product in products" :key="product.basicInfo.id">
            <div class="card mb-2" style="border: 2px solid #dbdbdb; border-radius: 10px;">
                <div v-if="onlyComponent === false"
                     class="card-header col-12 col-lg-12 p-2 d-flex flex-wrap align-items-center" style="border-bottom: 1px solid #dbdbdb;">
                    <div class="col-lg-2 flex-column ml-0 pe-1 w-40 pl-1 mb-2 mb-lg-0 text-truncate">
                        <a class="cursor-pointer" >
                            <span class="text-medium text-wrap">{{ product.basicInfo.id }} - {{
                                    product.basicInfo.name
                                }}</span>
                            <div class="d-flex align-items-center gap-2 mt-1 text-black">
                                <div class="d-flex align-items-center">
                                    <span class="text-small" style="padding-top: 2px;">SKU:</span>
                                    <strong class="fw-bold ms-1" style="font-size: 0.8rem;">{{ product.basicInfo.sku }}</strong>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="text-small" style="padding-top: 2px;">Cost:</span>
                                    <span class=" fw-bold ms-1" style="font-size: 0.8rem;">{{ product.basicInfo.cost }}</span>
                                </div>
                                <div class="ms-5" style="margin-top: -2px;">
                                    <span
                                        role="button"
                                        @click.prevent.stop="openPriceHistory(product)"
                                        class="text-medium fw-bold text-decoration-underline text-danger"
                                        style="font-size: 0.8rem;"
                                    >
                                        Show price history
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-auto ms-auto d-flex align-items-end gap-5 mb-2 mb-lg-0">
                        <div class="d-flex flex-column text-end">
                            <div class="d-flex align-items-center justify-content-end">
                                <span
                                    class="badge border border-secondary text-uppercase mb-1 py-1 px-2 d-flex align-items-center" 
                                    :style="{
                                        paddingTop: '5px',
                                        borderRadius: '14px',
                                        backgroundColor: product.basicInfo.ecommerceAvailableAmount > 0 ? '#28a745' : '#dc3545',
                                        color: '#ffffff',
                                        fontSize: '0.75rem',
                                        fontWeight: '600',
                                        marginBottom: '9px'
                                    }">{{
                                        product.basicInfo.ecommerceAvailableAmount
                                        > 0 ?
                                            'DISPONIBILE' : 'NON DISPONIBILE'
                                    }}<span class="badge ms-2 d-flex align-items-center bg-secondary" style="border-radius: .25rem;">{{
                                            product.basicInfo.ecommerceAvailableAmount
                                        }}</span></span>
                            </div>
                            <div class="text-small text-end fw-bold text-black">Stock</div>
                        </div>
                        <div class="d-flex flex-column text-end">
                            <div class="lh-1 fw-bold text-black" style="margin-bottom: 9px;">{{
                                    actionsList[product.basicInfo.actionId]
                                }}
                            </div>
                            <div class="text-small fw-bold text-black">Azione</div>
                        </div>
                        <div class="d-flex flex-column align-items-end">
                            <label class="switch switch-large my-1">
                                <input v-on:click="onClickEnableProduct(product.basicInfo.id)" :checked=product.basicInfo.enabled type="checkbox">
                                <span class="slider primary round"></span>
                            </label>
                            <div class="text-small fw-bold text-black">Attivo</div>
                        </div>
                        <div class="d-flex flex-column align-items-end">
                            <label class="switch switch-large my-1">
                                <input v-on:click="onClickOutOfProduction(product.basicInfo.id)" :checked="product.basicInfo.outOfProduction" type="checkbox">
                                <span class="slider primary round"></span>
                            </label>
                            <div class="text-small fw-bold text-black">Fuori prod.</div>
                        </div>
                    </div>
                </div>

                <div class="card-body" style="padding: unset;">
                    <div>
                        <!-- Filter out Gold prices (priceListId = 3) from regular price loop -->
                        <div v-for="price in product.prices.filter(p => p.priceListId !== 3)" :key="price.saleChannelId + '_' + (price.priceListId || 1)">
                            <!-- Unified container for price + discount -->
                            <div :id="'spinner_' + price.priceInfo.productPriceId" 
                                 :class="{
                                    'price-loading': loadingPrices.has(price.priceInfo.productPriceId)
                                }"
                                 class="d-flex w-100"
                                 :style="{
                                     border: (hasPriceExceedsLowest(price) || parseFloat(price.priceInfo.margin) <= 0) ? '2px solid #dc3545' : '1px solid #dbdbdb',
                                     overflow: 'hidden',
                                     backgroundColor: price.channelEnabled ? '#ffffff' : '#e9ecef'
                                 }">
                                <div v-if="loadingPrices.has(price.priceInfo.productPriceId)" class="spinner-overlay">
                                    <i class="fa fa-spinner fa-spin fa-2x"></i>
                                </div>
                                
                                <!-- Price Section -->
                                <div class="d-flex p-1" style="padding-left: 10px; padding-right: 10px; gap: 6px; flex-wrap: wrap; align-items: flex-start; min-height: 100%;">
                                    <div class="d-flex flex-column price-field-height">
                                        <label class="form-check custom-card position-relative p-0 m-0 cursor-pointer"
                                               style="min-width:36px; flex-basis: 0;">
                                            <input class="form-check-input position-absolute e-2 t-2 z-index-1 visually-hidden-focusable sr-only" type="checkbox"
                                                   v-model="price.channelEnabled" disabled>
                                            <span class="card form-check-label">
                                                <span alt="2" class="p-1 card-body text-center">
                                                    <div>
                                                        <span class="">
                                                            <img :src="getFlagIconSaleChannel(price.saleChannelId)"
                                                                 width="25">
                                                        </span>
                                                    </div>
                                                </span>
                                            </span>
                                        </label>
                                        <div class="text-dark text-small fw-bold label-bottom">{{ price.priceInfo.productPriceId }}</div>
                                    </div>
                                    <div class="d-flex flex-column price-field-height">
                                        <div class="d-flex align-items-center" style="min-height: calc(1.5em + 0.5rem + 2px);">
                                            <span class="fw-bold text-black" style="font-size: 0.8rem; margin-top: 2px">{{ price.priceInfo.salePrice }} €</span>
                                        </div>
                                        <div class="text-dark text-small fw-bold label-bottom">Sale Price (€)</div>
                                    </div>
                                    <div class="d-flex flex-column price-field-height">
                                        <div class="input-group" style="max-width: 68px;">
                                            <input v-model=price.priceInfo.price :readonly="price.saleChannelId !== 2 && price.priceInfo.custom === false" class="form-control form-control-sm no-spinner" min="0"
                                                   step="0.01"
                                                   type="number"
                                                   :disabled="!price.channelEnabled"
                                                   @input="onOriginalPriceChange(price, product.basicInfo)">
                                        </div>
                                        <div class="text-dark text-small fw-bold label-bottom">Original Price (€)</div>
                                    </div>
                                    <div class="d-flex flex-column price-field-height">
                                        <div class="input-group input-group-percent" style="max-width: 100px;">
                                            <span class="input-group-text">%</span>
                                            <input v-model=price.priceInfo.marginPerc :class="price.priceInfo.marginPerc > 0 ? 'form-control form-control-sm no-spinner' : 'form-control form-control-sm no-spinner is-invalid'" min="0" step="0.01"
                                                :disabled="!price.channelEnabled"   type="number">
                                        </div>
                                        <div class="text-dark text-small fw-bold label-bottom">Margine ({{ +parseFloat(price.priceInfo.margin).toFixed(3) }} €)
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column price-field-height">
                                        <div class="input-group" style="max-width: 60px;">
                                            <input :value="price.priceInfo.lowestSalePrice30d ?? ''" @input="price.priceInfo.lowestSalePrice30d = $event.target.value === '' ? null : parseFloat($event.target.value)" class="form-control form-control-sm no-spinner" min="0"
                                                 :disabled="!price.channelEnabled"  step="0.01" type="number" placeholder="0">
                                        </div>
                                        <div class="text-dark text-small fw-bold label-bottom">Lowest Price (€)</div>
                                    </div>

                                    <div class="d-flex flex-column" style="min-width: 35px; min-height: 55px;">
                                        <div v-if="price.saleChannelId !== 2">
                                            <div class="form-check form-switch min-h-auto">
                                                <input v-model="price.priceInfo.custom" class="form-check-input"
                                                      :disabled="!price.channelEnabled" type="checkbox" style="margin-top: 9px;">
                                            </div>
                                            <div class="text-dark text-small fw-bold" style="margin-top: 16px;">Custom</div>
                                        </div>
                                        <div v-else style="height: 40px;"></div>
                                    </div>



                                    <!-- <div class="mx-2" v-if="price.discountInfo.discountId">
                                        <div class="d-flex align-items-center">
                                        </div>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" :checked=price.discountInfo.discountEnabled
                                                :value=price.discountInfo.discountEnabled type="checkbox">
                                        </div>
                                        <div class="text-small">Discount</div>
                                    </div> -->

                                </div>

                                <!-- Discount Section -->
                                <div class="gap-1 align-items-center flex-grow-1 d-flex justify-content-center" 
                                     :class="{
                                         'bg-discount-active': price.discountInfo.discountId !== null,
                                         'bg-gray-custom': price.discountInfo.discountId === null
                                     }"
                                     :style="{ 
                                         padding: '8px 8px',
                                         minHeight: '100%',
                                         alignItems: 'flex-start'
                                     }">

                                    <div class="d-flex gap-1 flex-wrap" style="gap: 6px; align-items: flex-start;">

                                        <div class="d-flex align-items-center" style="margin-right: 4px; height: calc(1.5em + 0.5rem + 2px);">
                                            <svg class="acorn-icons acorn-icons-sale-tag" fill="none" height="20"
                                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="1.5" style="color: #CC4560;" viewBox="0 0 20 20"
                                                width="20"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_422:45)">
                                                    <path
                                                        d="M17.1273 5.20455C17.5247 5.38058 17.7629 5.79313 17.7166 6.22529L17.5176 8.08429C17.495 8.29556 17.5403 8.50854 17.6469 8.69235L18.5848 10.3097C18.8028 10.6857 18.753 11.1595 18.4616 11.4819L17.2079 12.8689C17.0654 13.0265 16.9769 13.2255 16.9551 13.4368L16.7632 15.2966C16.7186 15.7289 16.3998 16.0829 15.9745 16.1725L14.145 16.5577C13.9371 16.6015 13.7485 16.7103 13.6066 16.8685L12.3583 18.2603C12.0681 18.5838 11.6021 18.6829 11.2054 18.5053L9.49886 17.7417C9.30491 17.6549 9.08836 17.6321 8.88061 17.6767L7.05259 18.0689C6.62763 18.16 6.19244 17.9663 5.97584 17.5895L5.04412 15.9686C4.93823 15.7843 4.77642 15.6386 4.58214 15.5526L2.87272 14.7954C2.47533 14.6194 2.23715 14.2068 2.2834 13.7747L2.48237 11.9157C2.50498 11.7044 2.45971 11.4914 2.35312 11.3076L1.41523 9.69025C1.1972 9.31427 1.247 8.8405 1.53843 8.51806L2.79209 7.13105C2.93457 6.97342 3.02313 6.7745 3.04494 6.56314L3.23683 4.7034C3.28144 4.27107 3.6002 3.91705 4.0255 3.8275L5.85499 3.44227C6.06291 3.39849 6.25148 3.28961 6.39336 3.13144L7.64173 1.73967C7.93194 1.41612 8.3979 1.31708 8.79462 1.49461L10.5011 2.2583C10.6951 2.3451 10.9116 2.36786 11.1194 2.32328L12.9474 1.93109C13.3724 1.83992 13.8076 2.03368 14.0242 2.41049L14.9559 4.0314C15.0618 4.21561 15.2236 4.36131 15.4179 4.44736L17.1273 5.20455Z">
                                                    </path>
                                                    <path d="M6.46447 13.5355L13.5355 6.46445"></path>
                                                    <path
                                                        d="M7 7.5C7 7.22386 7.22386 7 7.5 7V7C7.77614 7 8 7.22386 8 7.5V7.5C8 7.77614 7.77614 8 7.5 8V8C7.22386 8 7 7.77614 7 7.5V7.5zM12 12.5C12 12.2239 12.2239 12 12.5 12V12C12.7761 12 13 12.2239 13 12.5V12.5C13 12.7761 12.7761 13 12.5 13V13C12.2239 13 12 12.7761 12 12.5V12.5z">
                                                    </path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_422:45">
                                                        <path d="M0 0H20V20H0z"></path>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <div></div>
                                        </div>

                                        <div>
                                            <div class="input-group" style="max-width: 55px;">
                                                <input v-model=price.discountInfo.discountPrice class="form-control form-control-sm no-spinner " min="0"
                                                       step="0.01"
                                                       type="number"
                                                       placeholder="0"
                                                       :disabled="!price.channelEnabled"
                                                       @input="updateDiscountPercentage(price, product.basicInfo)">
                                            </div>
                                            <div class="text-small">Discount (€)</div>
                                        </div>
                                        <div>
                                            <div class="input-group input-group-percent" style="max-width: 80px;">
                                                <span class="input-group-text">%</span>
                                                <input v-model="price.discountInfo.discountPercentage" class="form-control form-control-sm no-spinner" min="0"
                                                       step="0.01"
                                                       type="number"
                                                       placeholder="%"
                                                       :disabled="!price.channelEnabled"
                                                       @input="updateDiscountPrice(price, product.basicInfo)">
                                            </div>
                                            <div class="text-small">Discount (%)</div>
                                        </div>
                                        <div>
                                            <div class="input-group" style="max-width: 136px;">
                                                <input v-model="price.discountInfo.discountStartDate" autocomplete="off"
                                                       class="form-control form-control-sm" placeholder="dd-mm-yyyy --:--"
                                                       type="datetime-local"
                                                       :disabled="!price.channelEnabled"
                                                       step="60"
                                                       @change="autoPopulateDiscountEndDate(price.discountInfo)">
                                            </div>
                                            <div class="text-small">Discount Start</div>
                                        </div>
                                        <div style="max-width: 136px;">
                                            <div class="input-group">
                                                <input v-model="price.discountInfo.discountEndDate" autocomplete="off"
                                                       class="form-control form-control-sm"
                                                       placeholder="dd-mm-yyyy --:--" type="datetime-local"
                                                       :disabled="!price.channelEnabled"
                                                       step="60">
                                            </div>
                                            <div class="text-small">Discount End</div>
                                        </div>
                                        <div style="min-width: 150px;">
                                            <div class="input-group">
                                                <select v-model="price.discountInfo.discountEvent"
                                                        :class="getEventClass(price.discountInfo.discountEvent)"
                                                        class="form-select form-select-sm" style="min-height: unset;"
                                                        :disabled="!price.channelEnabled">
                                                    <option value="">No Event</option>
                                                    <option v-for="event in availableEvents" :key="event.value"
                                                            :selected="event.value === price.discountInfo.discountEvent"
                                                            :value="event.value">
                                                        {{ event.name }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="text-small">Event</div>
                                        </div>
                                        <div class="ms-2 d-flex flex-column align-items-center">
                                            <div class="input-group form-check form-switch min-h-auto">
                                                <!-- <div class=" mb-0"> -->
                                                    <input id="discountShowCountdownBanner" v-model=price.discountInfo.discountShowCountdownBanner
                                                        :checked=price.discountInfo.discountShowCountdownBanner
                                                        class="form-check-input"
                                                        type="checkbox" style="margin-top: 6px;"
                                                        :disabled="!price.channelEnabled">
                                                <!-- </div> -->
                                            </div>
                                            <div class="text-small" style="margin-top: 6px;">Countdown</div>
                                        </div>

                                        <input name="salesChannelId" type="hidden" value="" wire:model="salesChannelId">

                                        
                                        <!-- Delete Button -->
                                        <div class="ms-auto d-flex align-items-center">
                                            <button aria-label="Remove discount"
                                                    class="btn btn-icon btn-icon-only"
                                                    :disabled="!price.channelEnabled || price.discountInfo.discountId === null"
                                                    onclick="confirm('Sei sicuro di voler eliminare lo Sconto?') || event.stopImmediatePropagation();" type="button"
                                                    v-on:click=deleteDiscount(price,product.basicInfo)

                                                    >
                                                    <i class="fa fa-trash text-danger fa-xl"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Discount Section -->
                                
                                <!-- Save Button Section -->
                                <div class="d-flex align-items-center" style="padding: 8px;">
                                    <button class="btn btn-icon btn-icon-only bg-primary" 
                                            :disabled="!price.channelEnabled || loadingPrices.has(price.productPriceId)"
                                            onclick="confirm('Sei sicuro di voler continuare?') || event.stopImmediatePropagation()"
                                            type="button"
                                            v-on:click="saveProduct(product, price.priceInfo, price.discountInfo, price.saleChannelId)">
                                        <svg class="acorn-icons acorn-icons-save " fill="none" height="20"
                                             stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                             viewBox="0 0 20 20" width="20"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.5 18H14.5C15.9045 18 16.6067 18 17.1111 17.6629C17.3295 17.517 17.517 17.3295 17.6629 17.1111C18 16.6067 18 15.9045 18 14.5V7.62041C18 6.93871 18 6.59786 17.8952 6.28697C17.849 6.14988 17.788 6.01821 17.7134 5.89427C17.5441 5.6132 17.2842 5.39268 16.7644 4.95163L14.2654 2.83122C13.8506 2.47926 13.6431 2.30328 13.403 2.19029C13.2968 2.14034 13.1865 2.09982 13.0732 2.06922C12.817 2 12.545 2 12.0009 2H5.5C4.09554 2 3.39331 2 2.88886 2.33706C2.67048 2.48298 2.48298 2.67048 2.33706 2.88886C2 3.39331 2 4.09554 2 5.5V14.5C2 15.9045 2 16.6067 2.33706 17.1111C2.48298 17.3295 2.67048 17.517 2.88886 17.6629C3.39331 18 4.09554 18 5.5 18Z">
                                            </path>
                                            <path
                                                d="M14 18V13.75C14 13.0478 14 12.6967 13.8315 12.4444C13.7585 12.3352 13.6648 12.2415 13.5556 12.1685C13.3033 12 12.9522 12 12.25 12H7.75C7.04777 12 6.69665 12 6.44443 12.1685C6.33524 12.2415 6.24149 12.3352 6.16853 12.4444C6 12.6967 6 13.0478 6 13.75V18">
                                            </path>
                                            <path
                                                d="M14 8L7.75 8C7.04777 8 6.69665 8 6.44443 7.83147C6.33524 7.75851 6.24149 7.66476 6.16853 7.55557C6 7.30335 6 6.95223 6 6.25L6 2">
                                            </path>
                                        </svg>
                                    </button>
                                    <span class="ms-1">
                                        <i aria-hidden="true" class="fa fa-refresh fa-spin" wire:loading=""></i>
                                    </span>
                                </div>
                                <!-- End Save Button Section -->
                                
                            </div>
                            <!-- End Unified Container -->
                        </div>

                        <!-- Gold Price Line (only when showGold is true and data ready) -->
                        <div v-if="showGold && goldDataReady">
                            <!-- Unified container for Gold price -->
                            <div :id="'spinner_gold_' + product.basicInfo.id" 
                                 :class="{
                                    'price-loading': loadingPrices.has('gold_' + product.basicInfo.id),
                                    'border-danger-custom': parseFloat(product.goldPrice.margin) < 0
                                 }"
                                 class="d-flex w-100"
                                 :style="{
                                     border: parseFloat(product.goldPrice.margin) < 0 ? '2px solid #dc3545' : '1px solid #dbdbdb',
                                     overflow: 'hidden'
                                 }">
                                <div v-if="loadingPrices.has('gold_' + product.basicInfo.id)" class="spinner-overlay">
                                    <i class="fa fa-spinner fa-spin fa-2x"></i>
                                </div>

                                <!-- Price Section -->
                                <div class="d-flex p-1 gap-5" style="padding-left: 10px; padding-right: 10px; gap: 6px; flex-wrap: wrap; align-items: flex-start; min-height: 100%; min-width: 412px;">
                                    <div class="d-flex flex-column price-field-height" style="margin-left: 10px;">
                                        <label class="form-check custom-card position-relative p-0 m-0 cursor-pointer"
                                               style="min-width:36px; flex-basis: 0;">
                                            <span class="card form-check-label" style="background-color: #D9D9D9; margin-top: 5px;">
                                                <span alt="GOLD" class="p-1 card-body text-center">
                                                    <div>
                                                        <span class="fw-bold">GOLD</span>
                                                    </div>
                                                </span>
                                            </span>
                                        </label>
                                        <div class="text-dark text-small fw-bold label-bottom">
                                            {{ (product.goldPrice && product.goldPrice.productPriceId) || 'NEW' }}
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column price-field-height">
                                        <div class="d-flex align-items-center" style="min-height: calc(1.5em + 0.5rem + 2px);">
                                            <span class="fw-bold text-black" style="font-size: 0.8rem; margin-top: 10px">
                                                {{
                                                    parseFloat(
                                                        (product.goldPrice && product.goldPrice.salePrice) || 0
                                                    ).toFixed(2)
                                                }} €
                                            </span>
                                        </div>
                                        <div class="text-dark text-small fw-bold label-bottom">Sale Price (€)</div>
                                    </div>
                                    <div class="d-flex flex-column price-field-height">
                                        <div class="d-flex align-items-center" style="min-height: calc(1.5em + 0.5rem + 2px);">
                                            <span class="fw-bold text-black" style="font-size: 0.8rem; margin-top: 10px">
                                                {{
                                                    parseFloat(
                                                        (product.goldPrice && product.goldPrice.price) || 0
                                                    ).toFixed(2)
                                                }} €
                                            </span>
                                        </div>
                                        <div class="text-dark text-small fw-bold label-bottom">Original Price (€)</div>
                                    </div>
                                    <div class="d-flex flex-column price-field-height">
                                        <div class="d-flex align-items-center" style="min-height: calc(1.5em + 0.5rem + 2px);">
                                            <span class="fw-bold text-black" style="font-size: 0.8rem; margin-top: 10px">
                                                % {{
                                                    parseFloat(
                                                        (product.goldPrice && product.goldPrice.marginPerc) || 0
                                                    ).toFixed(2)
                                                }}
                                            </span>
                                        </div>
                                        <div class="text-dark text-small fw-bold label-bottom">
                                            Margine ({{
                                                parseFloat(
                                                    (product.goldPrice && product.goldPrice.margin) || 0
                                                ).toFixed(3)
                                            }} €)
                                        </div>
                                    </div>
                                </div>

                                <div class="gap-1 align-items-center flex-grow-1 d-flex justify-content-center" 
                                     :class="{
                                         'bg-gold-custom': product.goldPrice.custom,
                                         'bg-gray-custom': !product.goldPrice.custom // Using grey from discounts (assuming custom style for now, or just default)
                                     }"
                                     :style="{ 
                                         padding: '8px 8px',
                                         minHeight: '100%',
                                         alignItems: 'flex-start',
                                         maxWidth: '220px', /* Increased width */
                                         backgroundColor: !product.goldPrice.custom ? '#D9D9D9' : '' /* Inline fallback/override if needed */
                                     }">

                                    <div class="d-flex flex-wrap text-black" style="gap: 3rem !important; align-items: flex-start;">
                                        <div class="d-flex flex-column" style="min-width: 35px; min-height: 55px;">
                                            <div class="form-check form-switch min-h-auto">
                                                    <input
                                                        v-model="product.goldPrice.custom"
                                                        @change="onGoldCustomToggle(product)"
                                                        class="form-check-input"
                                                    type="checkbox" style="margin-top: 9px;">
                                            </div>
                                            <div class="text-small fw-bold" style="margin-top: 6px;">Custom</div>
                                        </div>
                                        <div class="d-flex flex-column price-field-height">
                                            <div class="input-group" style="max-width: 68px;">
                                                    <input
                                                        v-model.number="product.goldPrice.goldPrice"
                                                        @input="onGoldPriceChange(product)" 
                                                        :readonly="!product.goldPrice.custom"
                                                    class="form-control form-control-sm no-spinner text-black" 
                                                    min="0"
                                                    step="0.01"
                                                    type="number">
                                            </div>
                                            <div class="text-small fw-bold label-bottom" style="margin-top: unset;">Gold Price (€)</div>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                                <!-- Save Button Section -->
                                <div class="d-flex align-items-center" style="padding: 8px;">
                                    <button class="btn btn-icon btn-icon-only bg-primary"
                                            :disabled="loadingPrices.has('gold_' + product.basicInfo.id)"
                                            onclick="confirm('Sei sicuro di voler continuare?') || event.stopImmediatePropagation()"
                                            type="button"
                                            v-on:click="saveGoldProduct(product)">
                                        <svg class="acorn-icons acorn-icons-save" fill="none" height="20"
                                             stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                             viewBox="0 0 20 20" width="20"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.5 18H14.5C15.9045 18 16.6067 18 17.1111 17.6629C17.3295 17.517 17.517 17.3295 17.6629 17.1111C18 16.6067 18 15.9045 18 14.5V7.62041C18 6.93871 18 6.59786 17.8952 6.28697C17.849 6.14988 17.788 6.01821 17.7134 5.89427C17.5441 5.6132 17.2842 5.39268 16.7644 4.95163L14.2654 2.83122C13.8506 2.47926 13.6431 2.30328 13.403 2.19029C13.2968 2.14034 13.1865 2.09982 13.0732 2.06922C12.817 2 12.545 2 12.0009 2H5.5C4.09554 2 3.39331 2 2.88886 2.33706C2.67048 2.48298 2.48298 2.67048 2.33706 2.88886C2 3.39331 2 4.09554 2 5.5V14.5C2 15.9045 2 16.6067 2.33706 17.1111C2.48298 17.3295 2.67048 17.517 2.88886 17.6629C3.39331 18 4.09554 18 5.5 18Z">
                                            </path>
                                            <path
                                                d="M14 18V13.75C14 13.0478 14 12.6967 13.8315 12.4444C13.7585 12.3352 13.6648 12.2415 13.5556 12.1685C13.3033 12 12.9522 12 12.25 12H7.75C7.04777 12 6.69665 12 6.44443 12.1685C6.33524 12.2415 6.24149 12.3352 6.16853 12.4444C6 12.6967 6 13.0478 6 13.75V18">
                                            </path>
                                            <path
                                                d="M14 8L7.75 8C7.04777 8 6.69665 8 6.44443 7.83147C6.33524 7.75851 6.24149 7.66476 6.16853 7.55557C6 7.30335 6 6.95223 6 6.25L6 2">
                                            </path>
                                        </svg>
                                    </button>
                                    <span class="ms-1">
                                        <i aria-hidden="true" class="fa fa-refresh fa-spin" wire:loading=""></i>
                                    </span>
                                </div>
                                <!-- End Save Button Section -->
                            </div>
                            <!-- End Unified Container -->
                        </div>
                        <div v-else-if="showGold" class="mt-2 d-flex align-items-center" style="padding: 12px;">
                            <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
                            <span class="fw-bold text-muted" style="font-size: 0.85rem;">Loading Gold price...</span>
                        </div>
                        <!-- End Gold Price Line -->

                    </div>

                </div>
            </div>
        </div>
        <!-- END BODY PAGE -->

        <!-- PAGINATION -->
        <Pagination v-if="onlyComponent === false" :pagination="pagination" @changePage="productList"></Pagination>
        <!-- END PAGINATION -->
      <ProductFilters v-if="!onlyComponent" :initial-filters="activeFilters" @apply-filters="handleFiltersApplied"/>
      <ProductPriceHistoryModal ref="priceHistoryModal" :channel-names="channelNames" :flags="flags" />
    </div>
</template>

<script>
import axios from 'axios';
import Pagination from './Pagination.vue';
import InputSearchText from './InputSearchText.vue';
import ProductFilters from "./ProductFilters.vue";
import ProductPriceHistoryModal from "./ProductPriceHistoryModal.vue";

export default {
    components: {
        Pagination, InputSearchText, ProductFilters, ProductPriceHistoryModal
    },

    props: {
        initialFilters: {
            type: Object,
            default: () => null
        },
        defaultCompanyId: {
            type: Number,
            required: true
        },
        onlyComponent: { //FIXME: is better split the components and not use these props but we do not have any time to work
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
          activeFilters : {},
            selectedChannels: [this.defaultCompanyId],
            showGold: false,
            goldDataReady: true,
            currentFilters: this.initialFilters,
            products: [],
            actionsList: [],
            loadingPrices: new Set(),
            apiCallTimeout: null,
            isApplyingFilters: false, // Flag to prevent recursive filter updates
            isHandlingPopState: false, // Flag to prevent updateURL when handling browser navigation
            pagination: {
                currentPage: 1,
                perPage: 10,
                totalPages: 0,
                totalElements: 0,
            },
            flags: [
                {"code": 2, "label": "/img/cmw/sales_channels/cmw_it_b2c.png", "countryCode": "IT"},
                {"code": 1, "label": "/img/cmw/sales_channels/cmw_it_b2b.png", "countryCode": "IT"},
                {"code": 3, "label": "/img/cmw/sales_channels/cmw_de_b2c.png", "countryCode": "DE"},
                {"code": 4, "label": "/img/cmw/sales_channels/cmw_fr_b2c.png", "countryCode": "FR"},
                {"code": 6, "label": "/img/cmw/sales_channels/cmw_uk_b2c.png", "countryCode": "GB"},
                {"code": 8, "label": "/img/cmw/sales_channels/wb_it_b2c.png", "countryCode": "IT"},
            ],
            channelNames: [
                {"code": 2, "label": "CMW"},
                {"code": 1, "label": "B2B"},
                {"code": 3, "label": "CMW_DE"},
                {"code": 4, "label": "CMW FR"},
                {"code": 6, "label": "CMW UK"},
                {"code": 8, "label": "WINEBRIDGE"},
            ],

            availableEvents: [],
        }
    },
    mounted() {
        // Read from URL first (priority), then fallback to localStorage
        const urlFilters = this.readFiltersFromURL();
        
        // If URL has no filters, check localStorage
        if (Object.keys(urlFilters).length === 0) {
            const saved = localStorage.getItem('productFilters');
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    const oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);
                    const savedTime = new Date(data.timestamp);

                    if (savedTime > oneDayAgo && data.user === this.getCurrentUserId()) {
                        this.currentFilters = { ...this.currentFilters, ...data.filters };
                        this.activeFilters = data.filters;
                    }
                } catch (error) {
                    console.error('Error loading saved filters:', error);
                }
            }
        }

        // Add event listeners
        window.addEventListener('storage', this.handleStorageChange);
        window.addEventListener('filtersUpdated', this.handleFiltersUpdate);
        
        // Listen for browser back/forward buttons
        window.addEventListener('popstate', this.handlePopState);

        // Load product list
        this.productList();

        // Load available discount events
        this.loadAvailableEvents();
    },
    
    getCurrentUserId() {
        return document.querySelector('meta[name="user-id"]')?.getAttribute('content') || 'unknown';
    },
    
    handlePopState(event) {
        // Browser back/forward - read from URL and reload
        this.isHandlingPopState = true;
        
        try {
            // Read filters and pagination from URL
            const urlFilters = this.readFiltersFromURL();
            
            // Update currentFilters and activeFilters from URL
            if (Object.keys(urlFilters).length > 0) {
                this.currentFilters = { ...this.currentFilters, ...urlFilters };
                this.activeFilters = urlFilters;
            }
            
            // Use the page from URL (already set by readFiltersFromURL)
            const pageFromURL = this.pagination.currentPage;
            this.productList(pageFromURL);
        } finally {
            // Reset flag after a short delay to allow API call to complete
            this.$nextTick(() => {
                setTimeout(() => {
                    this.isHandlingPopState = false;
                }, 100);
            });
        }
    },

    beforeDestroy() {
        // Remove all event listeners
        window.removeEventListener('storage', this.handleStorageChange);
        window.removeEventListener('filtersUpdated', this.handleFiltersUpdate);
        window.removeEventListener('popstate', this.handlePopState);
    },
    watch: {
        currentFilters: {
            handler(newFilters) {
                // Prevent recursive calls when we're already applying filters
                if (this.isApplyingFilters) {
                    return;
                }
                if (newFilters) {
                    this.applyStoredFilters(newFilters);
                }
            },
            deep: true // Per osservare anche le modifiche negli oggetti annidati
        }
    },
    computed: {
        // Define computed properties here if needed
    },
    methods: {
        openPriceHistory(product) {
            let initialChannelId = null;
            
            // Logic to determine initial channel
            // If exactly one channel is selected in the main filter, use it.
            // Check activeFilters or selectedChannels
            
            // Prioritize activeFilters.channel (string 'IT', 'DE' etc? No, filter usually uses ID or code, need to check)
            // But selectedChannels is an array of IDs [1, 2, ...]
            
            // Actually, based on readFiltersFromURL:
            // user selects tabs => this.selectedChannels (array of IDs)
            
            if (this.selectedChannels && this.selectedChannels.length === 1) {
                // If only one channel is selected in the view, pre-select it
                initialChannelId = this.selectedChannels[0];
            } else {
                // If more than 1 channel is being viewed, do not preselect any channel (pass null)
                initialChannelId = null;
            }

            this.$refs.priceHistoryModal.open(product, initialChannelId);
        },

        /**
         * Load available discount events from backend
         */
        loadAvailableEvents() {
            axios.get('/comp/product-price/discount-events')
                .then(response => {
                    if (Array.isArray(response.data)) {
                        this.availableEvents = response.data;
                    }
                })
                .catch(error => {
                    console.error('Error loading available discount events', error);
                });
        },

        /**
         * Update URL query string with current filters, search, and pagination
         * Uses clean format without filters[] prefix
         */
        updateURL() {
            if (this.onlyComponent) return; // Skip URL updates in collection mode
            if (this.isHandlingPopState) return; // Skip URL updates when handling browser navigation
            
            const params = new URLSearchParams();
            
            // Add pagination
            params.set('page', this.pagination.currentPage);
            params.set('perPage', this.pagination.perPage);
            
            // Add search
            const textSearch = this.$refs.searchTextInput?.getTextSearch();
            if (textSearch) {
                params.set('search', textSearch);
            }
            
            // Add sales channels
            if (this.selectedChannels && this.selectedChannels.length > 0) {
                this.selectedChannels.forEach(channelId => {
                    params.append('salesChannelId[]', channelId);
                });
            }
            
            // Add Gold checkbox state
            if (this.showGold) {
                params.set('showGold', '1');
            }
            
            // Add ALL filters in clean format (no filters[] prefix)
            // Exclude margin and quantity filters (they are being removed)
            const excludedFilters = ['marginPerc_from', 'marginPerc_to', 'qty_from', 'qty_to'];
            
            if (this.currentFilters) {
                Object.entries(this.currentFilters).forEach(([key, value]) => {
                    // Skip excluded filters (margin and quantity)
                    if (excludedFilters.includes(key)) {
                        return;
                    }
                    
                    // Skip null, undefined, and empty string values (remove from URL)
                    if (value === null || value === undefined || value === '') {
                        return;
                    }
                    
                    // Handle arrays - comma separated
                    if (Array.isArray(value)) {
                        if (value.length > 0) {
                            params.set(key, value.join(','));
                        }
                    } else {
                        // Include all values (including defaults) in clean format
                        params.set(key, value);
                    }
                });
            }
            
            // Update URL without page reload
            const newURL = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState({ path: newURL }, '', newURL);
        },

        /**
         * Read filters from URL query string
         * Priority: URL > localStorage
         * Parses clean format (no filters[] prefix)
         */
        readFiltersFromURL() {
            if (this.onlyComponent) return {}; // Skip in collection mode
            
            const params = new URLSearchParams(window.location.search);
            const filters = {};
            
            // Read pagination
            const page = params.get('page');
            if (page) {
                this.pagination.currentPage = parseInt(page);
            }
            
            const perPage = params.get('perPage');
            if (perPage) {
                this.pagination.perPage = parseInt(perPage);
            }
            
            // Read search
            const search = params.get('search');
            if (search && this.$refs.searchTextInput) {
                this.$refs.searchTextInput.setTextSearch(search);
            }
            
            // Read sales channels
            const salesChannels = params.getAll('salesChannelId[]');
            if (salesChannels.length > 0) {
                this.selectedChannels = salesChannels.map(id => parseInt(id));
            }
            
            // Read Gold checkbox state
            const showGold = params.get('showGold');
            if (showGold === '1') {
                this.showGold = true;
            }
            
            // Read filters directly (clean format, no filters[] prefix)
            // List of known filter keys to avoid reading non-filter params
            // Exclude margin and quantity filters (they are being removed)
            const filterKeys = [
                'enabled', 'outOfProduction', 'hasImages', 'search', 'brand', 'tag', 
                'collection', 'order_by', 'category', 'vintage', 'winelist', 
                'philosophy', 'style', 'country', 'region', 'productionArea', 
                'action', 'channel', 'productstatus', 'price_from', 'price_to',
                'bollini', 'handcrafted', 'new', 'promotion', 'differentLowestPrice', 'discount'
            ];
            const excludedFilters = ['marginPerc_from', 'marginPerc_to', 'qty_from', 'qty_to'];
            
            for (const [key, value] of params.entries()) {
                // Skip pagination, search, and salesChannelId (already handled)
                if (key === 'page' || key === 'perPage' || key === 'search' || key.startsWith('salesChannelId')) {
                    continue;
                }
                
                // Only process known filter keys and exclude margin/quantity filters
                if (filterKeys.includes(key) && !excludedFilters.includes(key)) {
                    // Check if value contains comma (array filter)
                    if (value.includes(',')) {
                        filters[key] = value.split(',').map(v => {
                            const trimmed = v.trim();
                            // Convert to number if it's a numeric string
                            return isNaN(trimmed) ? trimmed : (trimmed.includes('.') ? parseFloat(trimmed) : parseInt(trimmed));
                        }).filter(v => v !== '');
                    } else {
                        // Convert values to appropriate types
                        let convertedValue = value;
                        
                        // Convert numeric values
                        if (key === 'price_from' || key === 'price_to') {
                            convertedValue = value === '' ? '' : (value.includes('.') ? parseFloat(value) : parseInt(value));
                        }
                        // Convert boolean values
                        else if (key === 'differentLowestPrice') {
                            convertedValue = value === 'true' || value === '1' || value === true || value === 1;
                        }
                        // Convert boolean-like strings to empty string (for outOfProduction, hasImages)
                        else if (key === 'outOfProduction' && value === 'no') {
                            convertedValue = '';
                        }
                        else if (key === 'hasImages' && value === 'no') {
                            convertedValue = '';
                        }
                        // Keep other string values as-is
                        
                        filters[key] = convertedValue;
                    }
                }
            }
            
            // Merge with current filters (only if not already applying filters to prevent recursion)
            // But allow updates during popstate (browser navigation)
            if (Object.keys(filters).length > 0 && (!this.isApplyingFilters || this.isHandlingPopState)) {
                this.currentFilters = { ...this.currentFilters, ...filters };
                this.activeFilters = filters;
            }
            
            return filters;
        },

        /**
         * Transform clean filter format to API format (filters[key]=value)
         * Used when making API calls to maintain backend compatibility
         */
        transformFiltersForAPI(filters) {
            const apiFilters = {};
            
            if (!filters) return apiFilters;
            
            Object.entries(filters).forEach(([key, value]) => {
                if (value === null || value === undefined || value === '') {
                    return;
                }
                
                // Handle arrays - convert to comma-separated string
                if (Array.isArray(value)) {
                    if (value.length > 0) {
                        apiFilters[key] = value.join(',');
                    }
                } else {
                    apiFilters[key] = value;
                }
            });
            
            return apiFilters;
        },

        /**
         * Handle filters applied event from ProductFilters component
         */
        handleFiltersApplied(activeFilters) {
            // Prevent recursive calls
            if (this.isApplyingFilters) {
                return;
            }
            
            this.isApplyingFilters = true;
            
            // Update current filters
            this.currentFilters = activeFilters;
            this.activeFilters = activeFilters;
            
            // Reset to page 1 when filters change
            this.pagination.currentPage = 1;
            
            // Load products with new filters
            this.productList(1);
            
            this.$nextTick(() => {
                this.isApplyingFilters = false;
            });
        },

        getEventClass(eventValue) {
            // Check both event and discountEvent
            const value = eventValue;
            if (!value) return '';

            const event = this.availableEvents.find(e => e.value === value);
            // Use the CSS-friendly class from backend (with dashes) instead of value (with underscores)
            return event ? `event-${event.class}` : '';
        },
        handleStorageChange(event) {
            // Prevent recursive calls
            if (this.isApplyingFilters) {
                return;
            }
            
            if (event.key === 'productFilters') {
                const filters = JSON.parse(event.newValue);
                if (filters) {
                    this.isApplyingFilters = true;
                    this.currentFilters = filters.filters;
                    this.applyStoredFilters(filters.filters);
                    this.$nextTick(() => {
                        this.isApplyingFilters = false;
                    });
                }
            }
        },

        handleFiltersUpdate(event) {
            // Prevent recursive calls
            if (this.isApplyingFilters) {
                return;
            }
            
            // Don't apply filters here - handleFiltersApplied is the main entry point
            // This event is just for syncing state, not for triggering API calls
            // The actual filter application happens via handleFiltersApplied event
        },

        applyStoredFilters(filters) {
            // Prevent recursive calls
            if (this.isApplyingFilters) {
                return;
            }
            
            this.isApplyingFilters = true;
            
            try {
                // Prioritize URL over localStorage
                // Check if URL has filters first
                const urlFilters = this.readFiltersFromURL();
                
                // If URL has filters, use them; otherwise use localStorage filters
                if (Object.keys(urlFilters).length > 0) {
                    // URL has filters, manually update currentFilters since readFiltersFromURL won't update it when isApplyingFilters is true
                    this.currentFilters = { ...this.currentFilters, ...urlFilters };
                    this.activeFilters = urlFilters;
                    this.pagination.currentPage = 1;
                    this.productList(1);
                } else if (filters) {
                    // No URL filters, use localStorage filters
                    // Update filters without triggering watcher (watcher is blocked by isApplyingFilters flag)
                    const newFilters = { ...this.currentFilters, ...filters };
                    this.currentFilters = newFilters;
                    this.activeFilters = filters;
                    this.pagination.currentPage = 1;
                    this.productList(1);
                }
            } finally {
                // Always reset the flag, even if there's an error
                this.$nextTick(() => {
                    this.isApplyingFilters = false;
                });
            }
        },
        getSaleChannelName(id) {
            return this.channelNames[id].label;
        },
        getFlagIconSaleChannel(code) {
            const flag = this.flags.find(flag => flag.code === code);
            return flag ? flag.label : '';
        },
        productList(page = 1, forceGold = false) {  
            // Ensure page is a valid number
            const pageNum = parseInt(page) || 1;
            const additionalFilters = localStorage.getItem('productFilters')
                ? JSON.parse(localStorage.getItem('productFilters'))
                : [];
            
            // Always update pagination state to ensure it matches the requested page
            // This is important for pagination clicks
            this.pagination.currentPage = pageNum;

            if (forceGold) {
                this.goldDataReady = false;
                if(!this.showGold){
                    return;
                }
            }
            // In collection mode, debounce API calls to prevent multiple requests
            if (this.onlyComponent) {
                if (this.apiCallTimeout) {
                    clearTimeout(this.apiCallTimeout);
                }
                this.apiCallTimeout = setTimeout(() => {
                    this.makeApiCall(pageNum, additionalFilters);
                }, 300); // 300ms debounce
                return;
            }
            
            // Make API call with the correct page number
            this.makeApiCall(pageNum, additionalFilters);
        },
        
        makeApiCall(page = 1, additionalFilters = []) {
            const params = new URLSearchParams({
                page: page,
                perPage: this.onlyComponent ? 1 : this.pagination.perPage, // Only 1 product for collection mode
                sort: 'products.id desc'
            });

            // Transform clean format filters to API format (filters[key]=value)
            const apiFilters = this.transformFiltersForAPI(this.currentFilters);
            
            // Add transformed filters to API params
            Object.entries(apiFilters).forEach(([key, value]) => {
                params.append(`filters[${key}]`, value);
            });

            // Add salesChannelId selezionati
            this.selectedChannels.forEach(channelId => {
                params.append('salesChannelId[]', channelId);
            });

            const textSearch = this.$refs.searchTextInput?.getTextSearch();
            if (textSearch) {
                params.append('search', textSearch);
            }
            
            // Add Gold price request flag
            if (this.showGold) {
                params.append('showGold', '1');
            }
            
            // Add eventuali filtri aggiuntivi
            if (Array.isArray(additionalFilters.filters)) {
                additionalFilters.forEach(filter => {
                    if (filter.field && filter.value) {
                        const operator = filter.operator ? filter.operator : '';
                        params.append(`filters[${filter.field}]`, operator + filter.value);
                    }
                });
            }

            // Make API call
            axios.get(`/comp/product-price/list?${params.toString()}`)
                .then(response => {
                    this.actionsList = [];
                    const freshProducts = response.data.products || [];
                    // Initialize Gold price data for each product based on response
                    freshProducts.forEach(product => {
                        if (product.prices) {
                            // Normalize discountEvent: convert null from backend to '' for frontend dropdown
                            product.prices.forEach(p => {
                                if (p.discountInfo && p.discountInfo.discountEvent === null) {
                                    p.discountInfo.discountEvent = '';
                                }
                            });

                            const goldPrice = product.prices.find(p => p.priceListId === 3 && p.saleChannelId === 2);
                            const italyPrice = product.prices.find(p => p.priceListId === 1 && p.saleChannelId === 2);
                            product.goldPrice = {
                                productPriceId: goldPrice ? goldPrice.priceInfo.productPriceId : null,
                                price: italyPrice ? italyPrice.priceInfo.price : 0,
                                salePrice: goldPrice ? goldPrice.priceInfo.salePrice : 0,
                                margin: goldPrice ? goldPrice.priceInfo.margin : 0,
                                marginPerc: goldPrice ? goldPrice.priceInfo.marginPerc : 0,
                                custom: goldPrice ? goldPrice.priceInfo.custom : false,
                                goldPrice: goldPrice ? goldPrice.priceInfo.salePrice : 0
                            };
                        }
                    });
                    this.products = freshProducts;
                    response.data.actionsList.forEach(element => {
                        this.actionsList[element.id] = element.name;
                    });

                    this.pagination = {
                        currentPage: response.data.pagination.currentPage,
                        perPage: response.data.pagination.perPage,
                        totalPages: response.data.pagination.totalPages,
                        totalElements: response.data.pagination.totalElements,
                    };
                    
                    // Update URL after successful API response
                    this.updateURL();
                    
                    // In collection mode, ensure we only have the specific product
                    if (this.onlyComponent && this.currentFilters?.search) {
                        this.products = this.products.filter(product => 
                            product.basicInfo.id.toString() === this.currentFilters.search.toString()
                        );
                    }
                })
                .catch(error => {
                    console.error("There was an error fetching the product list!", error);
                })
                .finally(() => {
                    if (this.showGold) {
                        this.goldDataReady = true;
                    }
                });
        },
        newDiscount(e, productInfo) {
            e.discountInfo = {
                discountId: 0,
                discountEnabled: true,
                discountPrice: e.priceInfo.price,
                discountPercentage: 0,
                discountStartDate: this.getTomorrowDate(),
                discountEndDate: this.getOneMonthAfterDate(),
                discountShowCountdownBanner: false,
                discountEvent: e.discountInfo?.discountEvent || '' // Use existing event
            };

            this.updateDiscountPercentage(e, productInfo);
        },


        // Metodi helper per le date
        getTomorrowDate() {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return this.toLocalDateTime(tomorrow.toISOString().slice(0, 16));
        },

        getThreeMonthsLaterDate() {
            const threeMonthsLater = new Date();
            threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
            return this.toLocalDateTime(threeMonthsLater.toISOString().slice(0, 16));
        },

        getTwoMonthsAfterDate(date) {
            const baseDate = new Date(date);
            const originalDay = baseDate.getDate();
            
            // Calculate target month and year
            const targetMonth = baseDate.getMonth() + 2;
            const targetYear = baseDate.getFullYear() + Math.floor(targetMonth / 12);
            const finalMonth = targetMonth % 12;
            
            // Get the last day of the target month
            const lastDayOfTargetMonth = new Date(targetYear, finalMonth + 1, 0).getDate();
            
            // Use the minimum of original day and last day of target month to prevent overflow
            const dayToUse = Math.min(originalDay, lastDayOfTargetMonth);
            
            const twoMonthsLater = new Date(targetYear, finalMonth, dayToUse, baseDate.getHours(), baseDate.getMinutes());
            return this.toLocalDateTime(twoMonthsLater.toISOString().slice(0, 16));
        },

        getOneMonthAfterDate(date) {
            const baseDate = date ? new Date(date) : new Date();
            const originalDay = baseDate.getDate();
            
            // Calculate target month and year
            const targetMonth = baseDate.getMonth() + 1;
            const targetYear = baseDate.getFullYear() + Math.floor(targetMonth / 12);
            const finalMonth = targetMonth % 12;
            
            // Get the last day of the target month
            const lastDayOfTargetMonth = new Date(targetYear, finalMonth + 1, 0).getDate();
            
            // Use the minimum of original day and last day of target month to prevent overflow
            const dayToUse = Math.min(originalDay, lastDayOfTargetMonth);
            
            const oneMonthLater = new Date(targetYear, finalMonth, dayToUse, baseDate.getHours(), baseDate.getMinutes());
            return this.toLocalDateTime(oneMonthLater.toISOString().slice(0, 16));
        },

        deleteDiscount(e, productInfo) {
            const discountId = e.discountInfo.discountId;
            const saleChannelId = e.saleChannelId;

            // Update UI immediately: Revert sale price to original price
            e.priceInfo.salePrice = e.priceInfo.price;
            // Recalculate margin
            this.margin(e, e.priceInfo.price, productInfo);

            // Reset immediato dell'oggetto discount
            const resetDiscount = {
                discountId: null,
                discountEnabled: false,
                discountPrice: null,
                discountPercentage: null,
                discountStartDate: null,
                discountEndDate: null,
                discountShowCountdownBanner: false,
                discountEvent: ''
            };

            // Aggiungi lo spinner
            this.loadingPrices.add(e.priceInfo.productPriceId);

            // Reset immediato
            e.discountInfo = {...resetDiscount};

            if (discountId !== 0 && discountId !== null) {
                axios.delete(`/comp/product-price/discount/${discountId}/${saleChannelId}`)
                    .catch(error => {
                        console.error("Error deleting discount:", error);
                        alert("Errore durante l'eliminazione dello sconto!");
                        // In caso di errore, ripristina lo stato precedente
                        // Note: ideally we should store previous state to restore fully
                        // checking reload might be safer or just alerting
                    })
                    .finally(() => {
                        this.loadingPrices.delete(e.priceInfo.productPriceId);
                    });
            } else {
                this.loadingPrices.delete(e.priceInfo.productPriceId);
            }
        },
        applyDiscount(originalPrice, discountedPrice) {

            if (!originalPrice || isNaN(originalPrice) || !discountedPrice || isNaN(discountedPrice)) {
                return 0;
            }

            if (originalPrice <= discountedPrice) {
                return 0;
            }

            const discountAmount = originalPrice - discountedPrice;
            let discountPercentage = (discountAmount / originalPrice) * 100;
            return parseFloat(discountPercentage.toFixed(2));

        },
        saveProduct(e, price, discount, saleChannelId) {
            const validate = this.validations(e, price, discount, saleChannelId);

            if (!validate) {
                return;
            }

            // Aggiungi l'ID alla lista dei prezzi in caricamento
            this.loadingPrices.add(price.productPriceId);

            if (price.productPriceId === true) {
                price.productPriceId = null;
            }

            const selectedChannels = this.selectedChannels == '' ? '2,1,3,4,6' : this.selectedChannels;

            // Logic to save product changes
            axios.post(`/comp/product-price?selectedChannels=${selectedChannels}`, {
                productId: e.basicInfo.id,
                price: {
                    id: price.productPriceId,
                    price: price.price,
                    salePrice: price.salePrice,
                    marginPerc: price.marginPerc,
                    margin: price.margin,
                    custom: price.custom,
                    lowestSalePrice30d: price.lowestSalePrice30d,
                },
                discount: {
                    id: discount.discountId,
                    price: discount.discountPrice,
                    enabled: discount.discountEnabled,
                    startDate: discount.discountStartDate,
                    endDate: discount.discountEndDate,
                    showCountdownBanner: discount.discountShowCountdownBanner,
                    event: discount.discountEvent || null // Use discountEvent instead of event
                },
                saleChannelId: saleChannelId,
            })
                .then(response => {
                    if (response.data.success && response.data.product) {
                        // Trova l'indice del prodotto da aggiornare
                        const productIndex = this.products.findIndex(
                            product => product.basicInfo.id === response.data.product.basicInfo.id
                        );

                        if (productIndex !== -1) {
                            // Crea copie profonde per evitare riferimenti
                            const updatedProduct = JSON.parse(JSON.stringify(response.data.product));

                            // Aggiorna direttamente l'array products
                            this.products[productIndex] = {
                                ...this.products[productIndex],
                                basicInfo: updatedProduct.basicInfo,
                                prices: updatedProduct.prices.map(newPrice => {
                                    const existingPrice = this.products[productIndex].prices.find(
                                        p => p.saleChannelId === newPrice.saleChannelId
                                    );
                                    
                                    // Normalize discountEvent: convert null from backend to '' for frontend dropdown
                                    if (newPrice.discountInfo && newPrice.discountInfo.discountEvent === null) {
                                        newPrice.discountInfo.discountEvent = '';
                                    }

                                    return {
                                        ...existingPrice,
                                        ...newPrice
                                    };
                                })
                            };
                        }

                        console.log("Product updated successfully!", response.data.product);
                    }
                })
                .catch(error => {
                    console.error("There was an error saving the product!", error);
                    
                    // Check if error is about lowest price exceeding price
                    if (error.response && error.response.data && error.response.data.error === 'PRICE_EXCEEDS_LOWEST') {
                        alert(error.response.data.message || "Lowest Price cannot be greater than Price!");
                    } else if (error.response && error.response.data && error.response.data.errors) {
                        // Handle validation errors
                        const errors = error.response.data.errors;
                        const errorMessages = Object.values(errors).flat().join('\n');
                        alert(errorMessages || "There was an error saving the product!");
                    } else {
                        alert("There was an error saving the product!");
                    }
                })
                .finally(() => {
                    this.loadingPrices.delete(price.productPriceId);
                });
        },
        validations(e, price, discount, saleChannelId) {

            if (discount.discountEnabled && discount.discountPrice <= 0) {
                alert("Discount price must be greater than zero!");
                return false;
            }

            if (price.margin <= 0) {
                return confirm("Warning: the margin is negative. Are you sure you want to continue?");
            }

            if (discount.discountEndDate <= discount.discountStartDate && discount.discountEnabled) {
                alert("The discount end date cannot be earlier than the start date!");
                return false;
            }

            // Check if discount price is valid
            if (discount.discountEnabled && discount.discountPrice > price.price) {
                alert("The discounted price cannot be greater than the original price!");
                return false;
            }

            // Check if discount dates are valid
            if (discount.discountEnabled && (!discount.discountStartDate || !discount.discountEndDate)) {
                alert("Please set both start and end dates for the discount!");
                return false;
            }

            // Check if discount start date is after end date
            if (discount.discountEnabled && new Date(discount.discountStartDate) > new Date(discount.discountEndDate)) {
                alert("The discount start date cannot be after the end date!");
                return false;
            }

            if (discount.discountPrice == price.price) {
                alert("The discount price cannot be the same as the original price!");
                return false;
            }

            // Check if lowestPrice > price
            if (price.lowestSalePrice30d !== null && 
                price.lowestSalePrice30d !== undefined && 
                price.lowestSalePrice30d > price.price) {
                alert(`Error: Lowest Price (${price.lowestSalePrice30d} €) cannot be greater than Price (${price.price} €). Please adjust the lowest price before saving.`);
                return false;
            }

            return true;
        },
        getCountryCode(saleChannelId) {
            const flag = this.flags.find(f => f.code == saleChannelId);
            return flag ? flag.countryCode : 'IT';
        },
        onOriginalPriceChange(price, productInfo) {
            // Update salePrice based on whether discount is active or not
            // CORRECT LOGIC: Discount is active ONLY if enabled AND currently within valid date range
            const now = new Date();
            const start = price.discountInfo.discountStartDate ? new Date(price.discountInfo.discountStartDate) : null;
            const end = price.discountInfo.discountEndDate ? new Date(price.discountInfo.discountEndDate) : null;

            const isDateValid = start && end && now >= start && now <= end;
            const hasActiveDiscount = price.discountInfo.discountEnabled && isDateValid;

            if (hasActiveDiscount) {
                // If discount active, we keep the Sale Price (Discount Price) FIXED.
                // We recalculate the Discount Percentage based on the new Original Price.
                this.updateDiscountPercentage(price, productInfo);
            } else {
                // No discount: Sale Price = Original Price
                price.priceInfo.salePrice = price.priceInfo.price;

                // Recalculate margin
                this.margin(price, price.priceInfo.salePrice, productInfo);
            }
        },
        updateDiscountPrice(product, productInfo) {
            console.log("updateDiscountPrice", product);

            if (!product.priceInfo.price || !product.discountInfo.discountPercentage) return;

            const percentage = parseFloat(product.discountInfo.discountPercentage);
            const originalPrice = parseFloat(product.priceInfo.price);

            if (isNaN(percentage) || isNaN(originalPrice)) return;

            // Calcola il nuovo prezzo scontato
            const discount = originalPrice * (percentage / 100);
            product.discountInfo.discountPrice = (originalPrice - discount).toFixed(2);

            this.margin(product, product.discountInfo.discountPrice, productInfo);
        },
        updateDiscountPercentage(product, productInfo) {
            console.log("updateDiscountPercentage", product);

            if (!product.priceInfo.price || !product.discountInfo.discountPrice) return;

            const originalPrice = parseFloat(product.priceInfo.price);
            const discountPrice = parseFloat(product.discountInfo.discountPrice);

            if (isNaN(originalPrice) || isNaN(discountPrice)) return;

            // Calcola la percentuale di sconto
            const discountAmount = originalPrice - discountPrice;
            const percentage = (discountAmount / originalPrice) * 100;
            product.discountInfo.discountPercentage = parseFloat(percentage.toFixed(2));

            this.margin(product, product.discountInfo.discountPrice, productInfo);
        },
        /**
         * Auto-populate discount end date when start date is set
         * Always updates end date to start date + 1 month, preserving the time from start date
         */
        autoPopulateDiscountEndDate(discountInfo) {
            if (!discountInfo.discountStartDate) return;
            
            try {
                // Parse the start date (preserving the user-entered time)
                const startDate = new Date(discountInfo.discountStartDate);
                
                // Check if valid date
                if (isNaN(startDate.getTime())) return;
                
                // Calculate end date: start date + 1 month (preserving the time from start date)
                const startDayOfMonth = startDate.getDate();
                const endDate = new Date(startDate);
                endDate.setMonth(endDate.getMonth() + 1);
                
                // If the day changed due to overflow (e.g., Jan 31 -> Mar 3), 
                // set to last day of target month
                if (endDate.getDate() !== startDayOfMonth) {
                    // Set to day 0 of next month = last day of target month
                    endDate.setDate(0);
                }
                
                // Format end date as datetime-local input format (YYYY-MM-DDTHH:mm)
                const endYear = endDate.getFullYear();
                const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
                const endDay = String(endDate.getDate()).padStart(2, '0');
                const endHours = String(endDate.getHours()).padStart(2, '0');
                const endMinutes = String(endDate.getMinutes()).padStart(2, '0');
                
                discountInfo.discountEndDate = `${endYear}-${endMonth}-${endDay}T${endHours}:${endMinutes}`;
            } catch (error) {
                console.error('Error auto-populating end date:', error);
            }
        },
        margin(e, salePrice, productInfo) {
            const countryCode = this.getCountryCode(e.saleChannelId);
            axios.post('/comp/product-price/calculate-margin', {
                price: salePrice,
                cost: productInfo.cost,
                vatClassId: productInfo.vatClassId, 
                countryCode: countryCode,
                productId: productInfo.id,
                salesChannelId: e.saleChannelId,
            })
                .then(response => {
                    console.log("Margin saved successfully!", response.data);
                    e.priceInfo.margin = parseFloat(response.data.margin).toFixed(3);
                    e.priceInfo.marginPerc = parseFloat(response.data.marginPerc).toFixed(2);
                })
                .catch(() => {
                    alert("There was an error getting the margin!");
                });
        },
        toLocalDateTime(dateTimeString) {
            const date = new Date(dateTimeString);
            const offset = date.getTimezoneOffset() * 2;
            const localDate = new Date(date.getTime() - offset * 60 * 1000);
            return localDate.toISOString().slice(0, 16);
        },
        onClickEnableProduct(productId) {
            axios.patch(`/comp/product-price/enable-product/${productId}`)
                .then(response => {
                    if (response.data.success) {
                        console.log("Product enabled/disabled successfully!", response.data);
                    } else {
                        alert("There was an error enabling/disabling the product!");
                    }
                })
                .catch(() => {
                    alert("There was an error enabling/disabling the product!");
                });
        },
        onClickOutOfProduction(productId) {
            axios.patch(`/comp/product-price/out-of-production/${productId}`)
                .then(response => {
                    if (response.data.success) {
                        console.log("Product out of production status changed successfully!", response.data);
                    } else {
                        alert("There was an error changing the out of production status!");
                    }
                })
                .catch(() => {
                    alert("There was an error changing the out of production status!");
                });
        },
        hasPriceExceedsLowest(price) {
            if (!price || !price.priceInfo) {
                return false;
            }
            const lowestPrice = price.priceInfo.lowestSalePrice30d;
            const currentPrice = price.priceInfo.price;
            return lowestPrice !== null && 
                   lowestPrice !== undefined && 
                   currentPrice !== null && 
                   currentPrice !== undefined &&
                   lowestPrice > currentPrice;
        },
        getGoldPriceInfo(product) {
            console.log('getGoldPriceInfo', product);
            
            // Lightweight helper for saveGoldProduct; product.goldPrice is normally initialized in makeApiCall
            if (!product.goldPrice) {
                return {
                    productPriceId: null,
                    price: 0,
                    salePrice: 0,
                    margin: 0,
                    marginPerc: 0,
                    custom: false,
                    goldPrice: 0,
                };
            }
            return product.goldPrice;
        },
        saveGoldProduct(product) {
            const goldInfo = this.getGoldPriceInfo(product);
            
            // If custom is ON, require a positive Gold price
            if (goldInfo.custom && (!goldInfo.goldPrice || goldInfo.goldPrice <= 0)) {
                alert("Gold Price must be greater than zero!");
                return;
            }
            
            // Add loading state
            this.loadingPrices.add('gold_' + product.basicInfo.id);
            
            // Prepare data
            const selectedChannels = this.selectedChannels == '' ? '2,1,3,4,6' : this.selectedChannels;

            // Build payload depending on custom toggle:
            // - custom ON: use entered goldPrice and existing margins
            // - custom OFF: set salePrice to null to restore default Gold price and mark custom false
            const payloadPrice = {
                id: goldInfo.productPriceId,
                price: goldInfo.price, // Original price (same as Italy)
                salePrice: goldInfo.goldPrice,
                marginPerc: goldInfo.marginPerc,
                margin: goldInfo.margin,
                custom: !!goldInfo.custom,
                lowestSalePrice30d: null,
                priceListId: 3 // GOLD
            };
            console.log('payloadPrice', payloadPrice);
            axios.post(`/comp/product-price?selectedChannels=${selectedChannels}`, {
                productId: product.basicInfo.id,
                price: payloadPrice,
                discount: {
                    id: null,
                    price: null,
                    enabled: false,
                    startDate: null,
                    endDate: null,
                    showCountdownBanner: false,
                    event: null
                },
                saleChannelId: 2, // CMW IT
                priceListId: 3 // GOLD
            })
            .then(response => {
                if (response.data.success && response.data.product) {
                    // Update product with new Gold price data
                    const productIndex = this.products.findIndex(
                        p => p.basicInfo.id === response.data.product.basicInfo.id
                    );
                    if (productIndex !== -1) {
                        // Update product prices from response
                        this.products[productIndex].prices = response.data.product.prices;
                        
                        // Update Gold price info from response
                        const goldPriceResponse = response.data.product.prices?.find(
                            p => p.saleChannelId === 2 && p.priceListId === 3
                        );
                        const italyPriceResponse = response.data.product.prices?.find(
                            p => p.saleChannelId === 2 && p.priceListId === 1
                        );
                        if (goldPriceResponse) {
                            this.products[productIndex].goldPrice = {
                                productPriceId: goldPriceResponse.priceInfo.productPriceId,
                                price: italyPriceResponse ? italyPriceResponse.priceInfo.price : 0,
                                salePrice: goldPriceResponse.priceInfo.salePrice,
                                margin: goldPriceResponse.priceInfo.margin,
                                marginPerc: goldPriceResponse.priceInfo.marginPerc,
                                custom: goldPriceResponse.priceInfo.custom,
                                goldPrice: goldPriceResponse.priceInfo.salePrice
                            };
                        }
                    }
                    console.log("Gold price updated successfully!", response.data.product);
                }
            })
            .catch(error => {
                console.error("There was an error saving the Gold price!", error);
                if (error.response && error.response.data && error.response.data.errors) {
                    const errors = error.response.data.errors;
                    const errorMessages = Object.values(errors).flat().join('\n');
                    alert(errorMessages || "There was an error saving the Gold price!");
                } else {
                    alert("There was an error saving the Gold price!");
                }
            })
            .finally(() => {
                this.loadingPrices.delete('gold_' + product.basicInfo.id);
            });
        },
        calculateGoldMargin(product) {
            const goldInfo = this.getGoldPriceInfo(product);
            
            // Clear previous timeout for this product
            if (product.goldMarginTimeout) {
                clearTimeout(product.goldMarginTimeout);
            }

            // Debounce the API call
            product.goldMarginTimeout = setTimeout(() => {
                const salePrice = parseFloat(goldInfo.goldPrice);
                
                if (!product.basicInfo || !product.basicInfo.cost || isNaN(salePrice)) return;

                axios.post('/comp/product-price/calculate-margin', {
                    price: salePrice,
                    cost: product.basicInfo.cost,
                    vatClassId: product.basicInfo.vatClassId,
                    countryCode: 'IT',
                })
                .then(response => {
                    goldInfo.margin = parseFloat(response.data.margin).toFixed(2);
                    goldInfo.marginPerc = parseFloat(response.data.marginPerc).toFixed(2);
                })
                .catch(error => {
                    console.error("Error calculating margin:", error);
                });
            }, 500); // 500ms debounce
        },
        onGoldCustomToggle(product) {
            const goldInfo = this.getGoldPriceInfo(product);
            if (!goldInfo.custom) {
                // Fetch calculated Gold Price from backend (Logic from GoldPriceCalculator)
                axios.post('/comp/product-price/calculate-gold', {
                    productId: product.basicInfo.id,
                    salesChannelId: 2 // Gold price reference is Italy
                })
                .then(response => {
                    if (response.data.success) {
                        // Update Gold Price and Margins with calculated values
                        goldInfo.goldPrice = parseFloat(response.data.price);
                        goldInfo.margin = parseFloat(response.data.margin).toFixed(2);
                        goldInfo.marginPerc = parseFloat(response.data.marginPerc).toFixed(2);
                        // Revert to "Original Price" (Italy Price)
                        this.calculateGoldMargin(product);
                    }
                })
                .catch(error => {
                    console.error("Error calculating default gold price:", error);
                    alert("Error calculating default gold price");
                });
            }
        },
        onGoldPriceChange(product) {
            this.calculateGoldMargin(product);
        }
    }
}
</script>

<style scoped>
.overflow-x {
    overflow-x: auto;
    white-space: nowrap;
    min-width: 100%;
    display: block;
}

/* Custom Gold Price Styles */
.bg-gold-custom {
    background-color: #E2D087 !important;
}

.bg-gray-custom {
    background-color: #F6F6F6 !important;
}

.border-danger-custom {
    border: 2px solid #dc3545 !important;
}

/* Discount Styles */
.bg-discount-active {
    background-color: #FFEBEB !important;
}

/* Override primary slider color to primary theme color when checked */
.switch input:checked + .slider.primary, form-check-input:checked {
    background-color: #992645 !important;
    border-color: #992645 !important;
}

/* Larger switch styles to match badge size */
.switch-large {
    width: 50px !important;
    height: 23px !important;
}

/* Non-active toggle: light gray background with white thumb */
.switch-large .slider {
    background-color: #e0e0e0 !important;
    border: none !important;
}

.switch-large .slider:before {
    height: 17px !important;
    width: 17px !important;
    left: 5px !important;
    bottom: 3px !important;
    background-color: #ffffff !important;
    border: none !important;
}

/* Active toggle: primary red background */
.switch-large input:checked + .slider {
    background-color: #992645 !important;
    border-color: #992645 !important;
}

.switch-large input:checked + .slider:before {
    -webkit-transform: translateX(22px) !important;
    -ms-transform: translateX(22px) !important;
    transform: translateX(22px) !important;
}

/* Opzionale: per migliorare l'aspetto della scrollbar */
.overflow-x::-webkit-scrollbar {
    height: 8px;
}

.overflow-x::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.overflow-x::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.overflow-x::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Assicurati che il contenuto interno sia disposto correttamente */
.d-flex {
    display: inline-flex !important;
    flex-wrap: nowrap;
}

.card-body {
    overflow-x: auto;
    padding: 0.5rem;
}

.card-body > div {
    min-width: max-content;
    /* Assicura che il contenuto non si comprima */
}

/* Stile per il contenitore flex interno */
.d-flex {
    display: flex !important;
    flex-wrap: nowrap !important;
}

/* Stile della scrollbar */
.card-body::-webkit-scrollbar {
    height: 8px;
}

.card-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.card-body::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.card-body::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.custom-separator-container {
    width: 5px;
    border-left: #000 1px solid;
    margin-left: 24px;
    margin-right: 24px;
}

.input-group {
    margin: 2px 0px 2px 0px;
}

/* Compact input groups for price/discount section */
.card-body .input-group {
    margin-bottom: 4px;
}

.m-top-10 {
    margin-top: 10px;
}

.price-loading {
    position: relative;
    pointer-events: none;
}

.price-loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    border-radius: 4px;
}

.spinner-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
    color: white;
}

.form-switch .form-check-input {
    width: 35px !important;
    height: 17px !important;
    border-radius: 14px !important;
}

/* Custom toggle styling - active state with primary color */
.form-switch .form-check-input:checked {
    background-color: #992645 !important;
    border-color: #992645 !important;
}

/* Countdown toggle styling */
.form-switch.min-h-auto .form-check-input:checked {
    background-color: #992645 !important;
    border-color: #992645 !important;
}

/* Apply border-radius and default border color to all inputs */
.form-control, .form-select, .custom-select {
    padding: 0.25rem 0.2rem !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-color: #B3B3B3;
}
.input-group-text {
    padding: 0.25rem 0.3rem 0.25rem 0.3rem !important;
    /* border-radius: 4px !important; */
    border-width: 1px !important;
    border-color: #B3B3B3;
}

.form-control:focus, .form-select:focus, .custom-select:focus {
    border-color: rgba(var(--primary-rgb), 1) !important;
}

.form-control.is-invalid {
    border-color: #dc3545 !important;
}
/* Target only inputs that have a % symbol (input-group-percent class) */
.input-group-percent .form-control {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}

/* Utility classes for repeated inline styles */
.text-black {
    color: #000000 !important;
}

.price-field-height {
    min-height: 55px;
}

.label-bottom {
    margin-top: auto;
}
</style>
